import angular from "angular";
import uiBootstrap from "angular-ui-bootstrap";
import angularMoment from "angular-moment";
import core from "../../core/core.module";
import kalendar from "../../kalendar/kalendar";

let mod = angular
    .module('bookingModule.bookingForm', [
        uiBootstrap,
        angularMoment,
        core,
        kalendar
    ])
    .run(['$templateCache', function ($templateCache) {
        $templateCache.put('stations-list-popup.html', require('./stations-list-popup.html'));
    }])
    .component('bookingForm', {
        template: require('./booking-form.html'),
        controller: [
            '$document',
            '$timeout',
            '$httpParamSerializer',
            'moment',
            'Data',
            'notifier',
            controller
        ],
        bindings: {
            popularRoutes: '<',
            inputParams: '<'
        }
    });

function controller($document, $timeout, $httpParamSerializer, moment, Data, notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        $document.find('body').addClass('start-bg');

        $ctrl.routeType = 'round-trip';
        $ctrl.depStation = null;
        $ctrl.arrStation = null;
        $ctrl.depDate = null;
        $ctrl.arrDate = null;
        $ctrl.adults = 1;
        $ctrl.children = 0;
        $ctrl.complexRoutes = [];

        $ctrl.depStationFocused = false;
        $ctrl.arrStationFocused = false;
        $ctrl.oneWayCalendarFocused = false;
        $ctrl.departureCalendarFocused = false;
        $ctrl.arrivalCalendarFocused = false;
        $ctrl.roundTripCalendarMode = 'single';
        $ctrl.depDateText = '';
        $ctrl.arrDateText = '';
        $ctrl.passengersCount = 1;
        $ctrl.passengersText = '1 взрослый';
        $ctrl.passengersControlOpen = false;

        $ctrl.calendarEndDate = moment().add(44, 'days').format('YYYY-MM-DD');

        if ($ctrl.inputParams) {
            setInputParams();
        }

        $timeout(function () {
            focusOnDepStation();
        }, 500);
    };

    function setInputParams() {

        $ctrl.routeType = $ctrl.inputParams.routeType;
        $ctrl.adults = +$ctrl.inputParams.adults;
        $ctrl.children = +$ctrl.inputParams.children;
        $ctrl.depStation = $ctrl.inputParams.routes[0].depStation;
        $ctrl.arrStation = $ctrl.inputParams.routes[0].arrStation;
        $ctrl.depDate = $ctrl.inputParams.routes[0].depDate;
        $ctrl.depDateText = moment($ctrl.depDate).format('DD MMM dd');

        if ($ctrl.routeType == 'round-trip') {
            $ctrl.arrDate = $ctrl.inputParams.routes[1].depDate || null;
            $ctrl.arrDateText = moment($ctrl.inputParams.routes[1].depDate).format('DD MMM dd');
            $ctrl.roundTripCalendarMode = 'range';
        }

        if ($ctrl.routeType == 'complex-routes') {
            for (let i = 1; i < $ctrl.inputParams.routes.length; i++) {
                $ctrl.complexRoutes.push({
                    depStation: $ctrl.inputParams.routes[i].depStation,
                    arrStation: $ctrl.inputParams.routes[i].arrStation,
                    depDate: $ctrl.inputParams.routes[i].depDate,
                    depDateText: moment($ctrl.inputParams.routes[i].depDate).format('DD MMM dd'),
                });
            }
        }

        $ctrl.passengersText = $ctrl.adults + ' взр. ' + $ctrl.children + ' дет.';
    }

    $ctrl.setRouteType = function (routeType) {
        $ctrl.routeType = routeType;
    };

    $ctrl.searchStations = function (fragment) {
        return Data.getStations(fragment);
    };

    $ctrl.swapStations = function (ind) {
        let sw;
        if (ind == undefined) {
            sw = $ctrl.depStation;
            $ctrl.depStation = $ctrl.arrStation;
            $ctrl.arrStation = sw;
        } else {
            sw = $ctrl.complexRoutes[ind].depStation;
            $ctrl.complexRoutes[ind].depStation = $ctrl.complexRoutes[ind].arrStation;
            $ctrl.complexRoutes[ind].arrStation = sw;
        }
    };

    $ctrl.toggleDepStationField = function (type, ind) {
        if (ind === undefined) {
            $ctrl.depStationFocused = type == 'focus';
        } else {
            $ctrl.complexRoutes[ind].depStationFocused = type == 'focus';
        }
    };

    $ctrl.toggleArrStationField = function (type, ind) {
        if (ind === undefined) {
            $ctrl.arrStationFocused = type == 'focus';
        } else {
            $ctrl.complexRoutes[ind].arrStationFocused = type == 'focus';
        }
    };

    $ctrl.depStationSelected = function (ind) {
        $timeout(function () {
            focusOnArrStation(ind);
        }, 300);
    };

    $ctrl.arrStationSelected = function (ind) {
        if ($ctrl.routeType != 'round-trip') {
            $timeout(function () {
                focusOnSingleCalendar(ind);
            }, 300);
        } else {
            $timeout(function () {
                focusOnRoundTripCalendarDepDate();
            }, 200);
        }
    };

    $ctrl.toggleOneWayCalendar = function (type, ind) {
        if (ind === undefined) {
            $ctrl.oneWayCalendarFocused = type == 'focus';
        } else {
            $ctrl.complexRoutes[ind].calendarFocused = type == 'focus';
        }
    };

    $ctrl.oneWayCalendarSelected = function (dates, ind) {
        if (ind === undefined) {
            $timeout(function () {
                $ctrl.depDate = dates[0];
                $ctrl.depDateText = moment(dates[0]).format('DD MMM dd');
                $ctrl.oneWayCalendarFocused = false;
                blurSingleCalendar();
                if ($ctrl.routeType == 'one-way') {
                    clickOnPassengersControl();
                } else {
                    if ($ctrl.complexRoutes.length) {
                        focusOnDepStation(0);
                    }
                }
            }, 300);
        } else {
            $timeout(function () {
                $ctrl.complexRoutes[ind].depDate = dates[0];
                $ctrl.complexRoutes[ind].depDateText = moment(dates[0]).format('DD MMM dd');
                $ctrl.complexRoutes[ind].calendarFocused = false;
                blurSingleCalendar(ind);
            }, 300);
        }
    };

    $ctrl.toggleRangeDepDateField = function (type) {
        $ctrl.departureCalendarFocused = type == 'focus';
        $ctrl.roundTripCalendarMode = 'single';
        toggleRoundTripCalendar();
    };

    $ctrl.toggleRangeArrDateField = function (type) {
        $ctrl.arrivalCalendarFocused = type == 'focus';
        $ctrl.roundTripCalendarMode = 'range';
        toggleRoundTripCalendar();
    };

    function toggleRoundTripCalendar() {
        if ($ctrl.roundTripCalendarTimeout) {
            $timeout.cancel($ctrl.roundTripCalendarTimeout);
        }
        if ($ctrl.departureCalendarFocused || $ctrl.arrivalCalendarFocused) {
            $ctrl.roundTripCalendarOpen = true;
        } else {
            $ctrl.roundTripCalendarTimeout = $timeout(function () {
                $ctrl.roundTripCalendarOpen = false;
            }, 500);
        }
    }

    $ctrl.roundTripCalendarSelected = function (dates) {
        if ($ctrl.departureCalendarFocused) {
            $timeout(function () {
                $ctrl.departureCalendarFocused = false;
                blurOnRoundTripCalendarDepDate();
                focusOnRoundTripCalendarArrDate();
                $ctrl.depDate = dates[0];
                $ctrl.depDateText = moment(dates[0]).format('DD MMM dd');
                $ctrl.arrDate = null;
                $ctrl.arrDateText = '';
            }, 200);
        }
        if ($ctrl.arrivalCalendarFocused) {
            if (dates.length == 1) {
                $timeout(function () {
                    $ctrl.depDate = dates[0];
                    $ctrl.depDateText = moment(dates[0]).format('DD MMM dd');
                    $ctrl.arrDate = null;
                    $ctrl.arrDateText = '';
                }, 200);
            } else {
                $timeout(function () {
                    $ctrl.arrivalCalendarFocused = false;
                    blurOnRoundTripCalendarArrDate();
                    clickOnPassengersControl();
                    $ctrl.arrDate = dates[1];
                    $ctrl.arrDateText = moment(dates[1]).format('DD MMM dd')
                }, 200);
            }
        }
    };

    $ctrl.withoutRoundTrip = function () {
        $timeout(function () {
            $ctrl.routeType = 'one-way';
            $ctrl.arrDate = null;
            $ctrl.arrDateText = '';
            clickOnPassengersControl();
        }, 300);
    };

    $ctrl.passengersControlToggle = function (open) {
        $ctrl.passengersControlOpen = open;
    };

    $ctrl.changePassCount = function (type, oper) {

        if (type == 'adult') {
            if (oper == 'minus') {
                $ctrl.adults--;
            } else {
                $ctrl.adults++;
            }
        } else {
            if (oper == 'minus') {
                $ctrl.children--;
            } else {
                $ctrl.children++;
            }
        }

        $ctrl.passengersCount = $ctrl.adults + $ctrl.children;

        if ($ctrl.adults && !$ctrl.children) {
            if ($ctrl.adults == 1) {
                $ctrl.passengersText = '1 взрослый';
            } else {
                $ctrl.passengersText = $ctrl.adults + ' взрослых';
            }
        }

        if ($ctrl.adults && $ctrl.children) {
            $ctrl.passengersText = $ctrl.adults + ' взр. ' + $ctrl.children + ' дет.';
        }

    };

    $ctrl.selectPopularRoute = function (route) {
        $ctrl.depStation = route.depStation;
        $ctrl.arrStation = route.arrStation;
    };

    $ctrl.addComplexRoute = function () {
        let prevRoute = $ctrl.complexRoutes.length ? $ctrl.complexRoutes[$ctrl.complexRoutes.length - 1] : null;
        $ctrl.complexRoutes.push({
            depStation: prevRoute ? prevRoute.arrStation : $ctrl.arrStation,
            arrStation: null,
            depDate: null,
            startDate: prevRoute ? prevRoute.depDate : $ctrl.depDate,
        });
    };

    $ctrl.deleteComplexRoute = function (ind) {
        $ctrl.complexRoutes.splice(ind, 1);
    };

    $ctrl.submit = function () {

        if (!validateForm()) {
            return;
        }

        let routes = $ctrl.depStation.code + '_' + $ctrl.arrStation.code + '_' + $ctrl.depDate;

        if ($ctrl.routeType == 'round-trip') {
            routes += '_' + $ctrl.arrDate;
        }

        if ($ctrl.routeType == 'complex-routes') {
            $ctrl.complexRoutes.forEach(function (route) {
                routes += ';' +
                    route.depStation.code + '_' +
                    route.arrStation.code + '_' +
                    route.depDate
            });
        }

        let params = {
            routeType: $ctrl.routeType,
            routes: routes,
            adults: $ctrl.adults,
            children: $ctrl.children
        };

        let query = $httpParamSerializer(params);

        window.location = '/booking?' + query;
    };

    function validateForm() {

        if (!$ctrl.depStation) {
            nf('Выберите станцию отправления');
            return false;
        }

        if (!$ctrl.arrStation) {
            nf('Выберите станцию прибытия');
            return false;
        }

        if (!$ctrl.depDate) {
            nf('Выберите дату отправления');
            return false;
        }

        if ($ctrl.routeType == 'round-trip' && !$ctrl.arrDate) {
            nf('Выберите дату отправления на обратный маршрут');
            return false;
        }

        if (!$ctrl.adults) {
            nf('Выберите кол-во пассажиров');
            return false;
        }

        if ($ctrl.passengersCount > 4) {
            nf('Допустимо не более 4 пассажиров');
            return false;
        }

        if ($ctrl.routeType == 'complex-routes') {
            if (!$ctrl.complexRoutes.length) {
                nf('Add route');
                return false;
            }
            for (let i = 0; i < $ctrl.complexRoutes.length; i++) {
                if (!$ctrl.complexRoutes[i].depStation) {
                    nf('Выберите станцию отправления');
                    return false;
                }
                if (!$ctrl.complexRoutes[i].arrStation) {
                    nf('Выберите станцию прибытия');
                    return false;
                }
                if (!$ctrl.complexRoutes[i].depDate) {
                    nf('Выберите дату отправления');
                    return false;
                }
            }
        }

        return true;
    }

    function nf(message) {
        notifier.errorNotify(message, 3000);
    }

    function focusOnDepStation(ind) {
        if (ind === undefined) {
            $document[0].getElementById('dep-station').focus();
        } else {
            $document[0].getElementById('dep-station-' + ind).focus();
        }
    }

    function focusOnArrStation(ind) {
        if (ind === undefined) {
            $document[0].getElementById('arr-station').focus();
        } else {
            $document[0].getElementById('arr-station-' + ind).focus();
        }
    }

    function focusOnSingleCalendar(ind) {
        if (ind === undefined) {
            $document[0].getElementById('one-way-calendar').focus();
        } else {
            $document[0].getElementById('one-way-calendar-' + ind).focus();
        }
    }

    function blurSingleCalendar(ind) {
        if (ind === undefined) {
            $document[0].getElementById('one-way-calendar').blur();
        } else {
            $document[0].getElementById('one-way-calendar-' + ind).blur();
        }
    }

    function focusOnRoundTripCalendarDepDate() {
        $document[0].getElementById('range-dep-date').focus();
    }

    function blurOnRoundTripCalendarDepDate() {
        $document[0].getElementById('range-dep-date').blur();
    }

    function blurOnRoundTripCalendarArrDate() {
        $document[0].getElementById('range-arr-date').blur();
    }

    function focusOnRoundTripCalendarArrDate() {
        $document[0].getElementById('range-arr-date').focus();
    }

    function clickOnPassengersControl() {
        if ($ctrl.routeType != 'complex-routes') {
            $document[0].getElementById('passengers-control-btn').click();
        }
    }

}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/booking-module/booking-form/booking-form.js